"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCanonicalUrl = void 0;
const getCanonicalUrl = (path, publicUrl) => {
    const url = new URL(path, publicUrl);
    url.hash = '';
    url.pathname = url.pathname.replace(/\/+$/, '') || '/';
    url.pathname = url.pathname.replace(/^(\/ponuky|\/en\/offers)\/1$/, '$1');
    // Preserve filters and pagination; only attribution parameters describe duplicate pages.
    Array.from(url.searchParams.keys()).forEach(key => {
        if (/^(utm_.+|gclid|dclid|fbclid|msclkid|gbraid|wbraid|_ga|_gl)$/i.test(key)) {
            url.searchParams.delete(key);
        }
    });
    url.searchParams.sort();
    return url.href;
};
exports.getCanonicalUrl = getCanonicalUrl;
